import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Editor, { TABLE_CELL_COMPONENT, FORM_FIELD_COMPONENT } from 'tuc-webui-base/components/editors/Editor';
import './PasswordEditor.scss';

class PasswordComponent extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
    object: PropTypes.shape({}),
    editing: PropTypes.bool,
    label: PropTypes.string,
    error: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
    readOnly: PropTypes.bool,
    property: PropTypes.shape({
      margin: PropTypes.string,
      autoComplete: PropTypes.string,
      description: PropTypes.string,
      idPrefix: PropTypes.string,
    }),
    form: PropTypes.bool,
  }

  static defaultProps = {
    error: null,
    object: undefined,
    readOnly: false,
    label: null,
    editing: false,
    property: undefined,
    form: false,
    value: '',
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleConfirmChange = this.handleConfirmChange.bind(this);
  }

  handleChange = (event) => {
    this.handleChangePassword(event.target.value, null);
  };

  handleConfirmChange = (event) => {
    this.handleChangePassword(null, event.target.value);
  }

  handleChangePassword(s1, s2) {
    const { value, onChange } = this.props;
    let [pwd1, pwd2] = Array.isArray(value) ? value : [value, value];
    if (s1 !== null) pwd1 = s1;
    if (s2 !== null) pwd2 = s2;
    onChange(pwd1 === pwd2 ? pwd1 : [pwd1, pwd2]);
  }

  render() {
    const {
      value,
      editing,
      error,
      label,
      readOnly,
      property,
      form,
    } = this.props;
    const InputProps = {
      readOnly: Boolean(readOnly === undefined ? true : readOnly),
      autoComplete: property.autoComplete || undefined,
    };
    const margin = property.margin || (form ? 'normal' : 'dense');
    const [value1, value2] = Array.isArray(value) ? value : [value, value];
    const [error1 = null, error2 = null] = error ? (Array.isArray(error) && error || [error]) : [];
    return (
      <div className="tuc-textfield-editor">
        {editing ? (
          <React.Fragment>
            <TextField
              error={!!error1}
              label={error1 || label}
              value={value1}
              type="password"
              margin={margin}
              onChange={this.handleChange}
              InputProps={InputProps}
              fullWidth={form}
              helperText={form && property ? property.description : undefined}
              id={form && property && property.idPrefix ? `${property.idPrefix}Password` : undefined}
            />
            <TextField
              error={!!error2}
              label={error2 || (error1 ? 'Confirm password' : 'Confirmed password')}
              value={value2}
              type="password"
              margin={margin}
              onChange={this.handleConfirmChange}
              InputProps={InputProps}
              fullWidth={form}
              helperText={form && property ? property.description : undefined}
              id={form && property && property.idPrefix ? `${property.idPrefix}ConfirmPassword` : undefined}
            />
          </React.Fragment>
        ) : (
          value
        )}
      </div>
    );
  }
}

export default class PasswordEditor extends Editor {
  constructor(name, components, validation) {
    super(name || 'password', Object.assign({}, {
      [TABLE_CELL_COMPONENT]: [PasswordComponent],
      [FORM_FIELD_COMPONENT]: [PasswordComponent],
    }, components));
    this.validation = validation;
    const makeValidator = (expression, message) => {
      const regexp = new RegExp(expression);
      return (s) => {
        const str = Array.isArray(s) ? s[0] : (s || '');
        return str.match(regexp) ? null : message;
      };
    };
    if (validation && validation.length) {
      let unconfirmedPasswordMsg = 'Confirmed password does not match password';
      this.validators = validation.map((v) => {
        if (v.expression) {
          return makeValidator(v.expression, v.message);
        }
        unconfirmedPasswordMsg = v.message;
        return null;
      }).filter(o => o);
      this.validators.push(s => (Array.isArray(s) ? [null, unconfirmedPasswordMsg] : null));
    }
  }

  getFilterValue(value) {
    return value && value.toString() || '';
  }

  getDefaultValidators() {
    return this.validators;
  }
}
